module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cepheus/cep_vis-554844d70fcad3c068d9890e076fe456.jpg";